"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var avatars_1 = require("components/Avatar/avatars");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var NotFoundPlaceHolder = function () { return (React.createElement("div", { key: 'no-additionla-letter', className: 'no-additional-letters' },
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("additionalLettersView/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("additionalLettersView/emptyList/message")))); };
exports.default = NotFoundPlaceHolder;
